import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext(null);

// ⚠️ MODE TEST - Désactiver le login temporairement
const TEST_MODE = false;
const TEST_USER = {
  id: 'test-user-001',
  email: 'test@atom-group.ch',
  full_name: 'Test User (Dev)',
  role: 'admin',
  team_id: null,
  created_at: new Date().toISOString(),
  is_active: true
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is authenticated on mount
    const initAuth = async () => {
      // ⚠️ MODE TEST - Bypass authentication
      if (TEST_MODE) {
        console.warn('⚠️ MODE TEST ACTIVÉ - Authentification désactivée');
        setUser(TEST_USER);
        // Set a fake token for API calls
        localStorage.setItem('access_token', 'test-token-dev');
        setLoading(false);
        return;
      }
      
      if (authService.isAuthenticated()) {
        try {
          const userData = await authService.getMe();
          setUser(userData);
        } catch (error) {
          console.error('Failed to get user:', error);
          authService.logout();
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = async (credentials) => {
    const { user: userData } = await authService.login(credentials);
    setUser(userData);
    return userData;
  };

  const signup = async (userData) => {
    const { user: newUser } = await authService.signup(userData);
    setUser(newUser);
    return newUser;
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
